<template>
  <div class="main_view">
    <div class="form_view">
      <el-card v-loading="loading">
        <div class="result_logo">
            <img :src="logo" style="width: 100PX">
        </div>
        <div class="dealer_name">
            <span>{{dealerName}}</span>
        </div>
        <div class="dealer_content" v-show="showInfo">
          <div class="dealer_content_text" v-show="havaDealerInfo">
            <div v-for="item in authInfos" style="padding-bottom: 10PX;padding-left: 10PX">
              <div class="level desc_content">
                <div class="custom-bullet-big"></div>
                <div class="title_div_big">授权级别：{{item.authorizationLevel}}</div>
              </div>
              <div class="market desc_content desc_level2">
                <div class="custom-bullet-small"></div>
                <div class="title_div_small">授权市场：{{item.authorizedMarket}}</div>
              </div>
              <div  class="area desc_content desc_level2">
                <div class="custom-bullet-small"></div>
                <div class="title_div_small">授权区域：{{item.authorizationArea}}</div>
              </div>
              <div class="smn desc_content desc_level2">
                <div class="custom-bullet-small"></div>
                <div class="title_div_small">授权机型：{{item.authorizedSMN}}</div>
              </div>
              <div class="smn desc_content desc_level2">
                <div class="custom-bullet-small"></div>
                <div class="title_div_small">有效期：{{item.certificatePeriod}}</div>
              </div>
            </div>
          </div>
          <div class="dealer_content_error" v-show="!havaDealerInfo">
              <div class="err_inf">抱歉，系统暂未查询到该经销商授权信息！<br/>请确保输入名称准确再次尝试！</div>
          </div>
        </div>
      </el-card>
      <el-row style="display: flex">
        <el-col :xl="6" class="back_btn" >
          <el-button type="danger" style="width: 100%;" @click="goBack">返回</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import CumminsLogo from '@/assets/img.png'
import SuccessLogo from '../assets/success.png'
import FailLogo from '../assets/FailLogo.png'
import axios from "axios";
export default {
  name: 'DealerInfo',
  data () {

    return {
      showInfo:false,
      loading:true,
      havaDealerInfo:false,
      dealerName:"",
      logo: "",
      authInfos: [
        // {
        //   "authStatus": "已生效",
        //   "authorizedSMN": "L9 CM2670 L134C",
        //   "authorizedMarket": "车用市场（HDT）;工业市场",
        //   "authorizationLevel": "全职",
        //   "authorizationArea": "湖南省,河北省"
        // },
        // {
        //   "authStatus": "已生效",
        //   "authorizedSMN": null,
        //   "authorizedMarket": null,
        //   "authorizationLevel": "燃油服务",
        //   "authorizationArea": "湖南省,河北省"
        // },
        // {
        //   "authStatus": "已生效",
        //   "authorizedSMN": null,
        //   "authorizedMarket": null,
        //   "authorizationLevel": "后处理服务",
        //   "authorizationArea": "湖南省,河北省"
        // },
        // {
        //   "authStatus": "已生效",
        //   "authorizedSMN": null,
        //   "authorizedMarket": null,
        //   "authorizationLevel": "HHP全职",
        //   "authorizationArea": null
        // }
      ]


    }
  },
  methods:{
    goBack(){
      this.$router.go(-1);
    },
    handleResize() {
      console.log(window.innerWidth,"屏幕宽度") ;
      console.log(window.innerHeight,"屏幕高度");
    },

  },
  computed: {
    dealerInfo() {
      return this.$store.state.dealerInfo;
    }
  },
  mounted() {
    if(this.dealerInfo.phoneNumber===undefined && this.dealerInfo.equipment===undefined && this.dealerInfo.dealerName===undefined){
      this.$router.push("/")
    }else{
      axios.post('https://cma-svc-prod.cummins.com.cn/portal/common/getDealerInfoByOutSystem', this.dealerInfo,{
      // axios.post('/portal/common/getDealerInfoByOutSystem', this.dealerInfo,{
        headers: {
          'Content-Type': 'application/json',
          "Accept":"*/*"
        }})
        .then(response => {

          let data=response.data.data
          this.dealerName=data.customerName
          let authInfo=data.authInfos
          if(authInfo.length>0){
            //成功
            this.logo=SuccessLogo
            this.authInfos=authInfo
            this.havaDealerInfo=true
          }else{
            this.logo=FailLogo
            this.havaDealerInfo=false
          }
          this.loading=false
          this.showInfo=true
        })
        .catch(error => {
          console.error('There was an error!', error);
        });
    }

  },
  watch:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_view{
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
}
.form_view{
  margin: auto;
  width: 500PX;
}
/deep/ label{
  margin-bottom: 0PX;
}
/deep/ .el-form-item__label{
  text-align:left !important;
}
/deep/ .el-form-item{
  margin-bottom: 10PX !important;
}
/deep/ .el-card{
  background-color:rgb(242,242,242);
  height: 70vh;
}
.el-card__body, /deep/.el-main{
  padding: 30PX !important;
}
.title_span{
  padding-left: 5PX;
  font-size: 20PX;
  font-weight: bold;
}
.yinsi{
  line-height: 43PX;
  text-align: left;
}
.last_opt{
  margin-bottom: 10PX;
}
.select_btn{
  width: 100%;
}
.input_captch{
  flex: 1;
  padding-right: 10PX;
}
.cap_desc{
  width: 120PX;
}
.form_title{
  color: black;
  font-size: 16PX;
}
.last_btn{
  margin-top: 10PX;
}
.title_cummins{
  display: flex;
  align-items: center;
  justify-content:center;
  padding-bottom: 20PX;
}
.result_logo{

}
.dealer_name{
  margin-top: 10PX;
  text-align: center;
  font-size: 24PX;
}
.dealer_content{
  margin-top: 10PX;
  height: 45vh;
}
.dealer_content_text{
  padding-top: 10PX;
  margin: auto;
  width: 90%;
  height: 100%;
  background-color: white;
  overflow-y: auto;
}
.dealer_content_error{
  margin: auto;
  width: 90%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.err_inf{
  margin-top: 50PX;
  font-size: 21PX;
  color: red;
}
.custom-bullet-big{
  width: 12PX;
  height: 12PX;
  background-color: #f0f0f0;
  background-color: red;
  border-radius: 50%;
}
.custom-bullet-small{
  width: 10PX;
  height: 10PX;
  background-color: #f0f0f0;
  background-color: red;
  border-radius: 50%;
  margin-top: 8PX;
}
.title_div_big{
  font-size: 18PX;
  padding-left: 5PX;
}
.title_div_small{
  font-size: 15PX;
  padding-left: 5PX;
  padding-top: 2PX;
  width: 100%;
  text-align: left;
}
.desc_content{
  display: flex;
  align-items: center;
}
.desc_level2{
  align-items: flex-start;
  padding-left: 20PX;
}
.level{
  color: red;
}
.back_btn{
  padding-top: 20PX;
  margin: auto;
}
@media screen and (max-width: 768px) {
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
  .el-card{
    height: 75vh;
  }

}

@media (device-height:480px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone4/4s */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}

@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone5 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}

@media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}
@media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 Plus */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/dealerInfo.vue